import { Image, Stack, Text, merge } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useCallback } from 'react';
import arrowIcon from '../../../assets/icons/svg/arrow.svg';
import { useLotsCommerciaux, useLotsCommerciauxManager } from '../../../contexts/lotCommercialContext';
import Vignette from '../../Vignette';
import UserMenuDropdownItem from './UserMenuDropdownItem';

const UserMenuDropdown = () => {

    const { lotCommercialActif, lotsCommerciaux, idOperationActive, idLotCommercialActif } = useLotsCommerciaux();
    const { updateLotCommercialActif } = useLotsCommerciauxManager();

    const [isExpanded, { toggle }] = useBoolean(false);

    const optionBaseStyles = {
        root: {
            minHeight: 62,
            paddingLeft: 24,
            paddingRight: 24,
            selectors: { "&:last-child > span": { borderBottom: "none" } }
        }
    };

    const optionTextBaseStyles = {
        root: {
            alignItems: "center",
            borderBottom: "1px solid #DADADA",
            color: "#8A8A8A",
            display: "flex",
            flexGrow: 1,
            fontSize: 16,
            fontWeight: 400,
            height: "100%",
            lineHeight: "15px",
            paddingLeft: 48,
            paddingRight: 48,
        },
    };

    const styles = {
        arrow: {
            root: {
                cursor: "pointer",
                transform: isExpanded ? "rotate(180deg)" : "unset",
            },
        },
        activeItem: {
            root: {
                backgroundColor: "rgba(236, 236, 236, 0.7)",
                minHeight: 62,
                padding: "0 24px",
            },
        },
        activeItemText: {
            root: {
                fontSize: 16,
                fontWeight: 700,
                lineHeight: "15px",
            },
        },
        options: {
            root: {
                display: isExpanded ? "flex" : "none",
            },
        },
        option: merge(
            optionBaseStyles,
            {
                root: {
                    selectors: {
                        "&:hover": {
                            borderLeft: "2px solid red",
                            cursor: "pointer",
                            paddingLeft: 22
                        }
                    }
                }
            }
        ),
        optionDisabled: merge(
            optionBaseStyles,
            { root: { color: "red" } }
        ),
        optionText: merge(
            optionTextBaseStyles,
            { root: { color: "red" } }
        ),
        optionTextDisabled: merge(
            optionTextBaseStyles,
            { root: { color: "red" } }
        ),
        outer: { root: { borderBottom: "1px solid #DADADA" } }
    };

    const onClickOption = useCallback((idOperation, idLotCommercial) => () => {
        updateLotCommercialActif(idOperation, idLotCommercial);
        toggle();
    }, [toggle, updateLotCommercialActif]);

    if (lotsCommerciaux.length === 0) return null;
    else return <Stack styles={styles.outer}>
        {!!lotCommercialActif &&
            <Stack horizontal horizontalAlign="space-between" verticalAlign="center" styles={styles.activeItem}>
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 11 }}>
                    <Vignette src={lotCommercialActif.src} />
                    <Text styles={styles.activeItemText}>{[lotCommercialActif.numero, lotCommercialActif.nomCommercial].join(" - ")}</Text>
                </Stack>
                {lotsCommerciaux.length > 1 && <Image src={arrowIcon} onClick={toggle} styles={styles.arrow} />}
            </Stack>
        }
        <Stack styles={styles.options}>
            {lotsCommerciaux
                .filter(lot => lot.idOperation !== idOperationActive || lot.idLotCommercial !== idLotCommercialActif)
                .map(((lot, index) => {
                    const { activationCapsuleClient, idLotCommercial, idOperation } = lot;
                    return <UserMenuDropdownItem
                        disabled={!activationCapsuleClient}
                        key={index}
                        lotCommercial={lot}
                        onClick={onClickOption(idOperation, idLotCommercial)}
                    />;
                }))
            }
        </Stack>
    </Stack>;

};

export default UserMenuDropdown;